export default "__VITE_ASSET__DFD5c9i8__"